/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Exhibition } from '../../models/exhibition';
import { NewExhibition } from '../../models/new-exhibition';

export interface InventoryCreateExhibition$Params {
  inventoryId: string;
      body?: NewExhibition
}

export function inventoryCreateExhibition(http: HttpClient, rootUrl: string, params: InventoryCreateExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<Exhibition>> {
  const rb = new RequestBuilder(rootUrl, inventoryCreateExhibition.PATH, 'post');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Exhibition>;
    })
  );
}

inventoryCreateExhibition.PATH = '/inventory/exhibitions';
